import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getAuthReferenceData = createAsyncThunk(
  'stop/getAuthReferenceData',
  async (params) => {
    const { authReferenceUrl, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(authReferenceUrl, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    //console.log('### GET AUTH REF DATA');
    //console.log(data);
    return data === undefined ? null : data;
  }
);

const authReferenceSlice = createSlice({
  name: 'stop/authReferenceSlice',
  initialState: null,
  reducers: {
    resetAuthReference: () => null,
  },
  extraReducers: {
    [getAuthReferenceData.fulfilled]: (state, action) => action.payload,
  },
});

export const { resetAuthReference } = authReferenceSlice.actions;

export default authReferenceSlice.reducer;
